// extracted by mini-css-extract-plugin
export default {"nav_2":"index-module_nav_2_r4HCp","navTitle":"index-module_navTitle_ndR7n","navList":"index-module_navList_M2Aiq","navItem":"index-module_navItem_htuDO"};